/** 
 * Enumeration representing the status of an exclusive content subscription.
 * 
 * Matches Flutter's ExclusiveContentSubscriptionStatus from 
 * lib/data/enums/exclusive_content_subscription_status.dart 
*/
export enum ExclusiveContentSubscriptionStatus {
    requested = 0,
    active = 1,
    inactive = 2,
    cancelled = 3,
}